// Pokud nechceme výchozí nette validační error (otevírá se v dialog okně)
// použijeme na form elementu data-live-validation na formuláři
// Tím dojde k validaci vždy po změně a validační hláška bude vypsána pod input
// pokud bychom nechtěli vypisovat pod input, tak dáme na div, za který chceme vložit validační hlášku data-live-validation-group

// validating ---------------------------------------------------------------------------------------
function showErrors(errors, focus) {
	// clear errors
	errors.forEach(function (error) {
		if (error.message) {
			removeErrors(error.element);
		}
	});

	const appended = [];

	// append errors
	errors.forEach(function (error) {
		if (error.message && error.element) {
			let element = error.element;
			if (element.closest('[data-live-validation-group]')) {
				element = element.closest('[data-live-validation-group]');
			}

			if (!appended[element]) {
				appended[element] = [];
			}

			if (appended[element].includes(error.message)) {
				return;
			}
			appended[element].push(error.message);

			const invalidFeedback = document.createElement('div');
			invalidFeedback.classList.add('invalid-feedback');
			invalidFeedback.textContent = error.message;

			element.parentNode.insertBefore(invalidFeedback, element.nextSibling);
			element.classList.add('is-invalid');

			if (focus) {
				if (element.focus) {
					element.focus();
				}

				var header = document.querySelector('header[data-move-focus-in-form="true"]');
				if (header instanceof Element) {
					//advertiserovi posunu scroll o vysku listy co je nad strankou
					element.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
				focus = false;
			}
		}
	});
}

function removeErrors(element) {
	if (element instanceof HTMLFormElement) {
		element.querySelectorAll('.is-invalid').forEach((input) => {
			input.classList.remove('is-invalid');
		});
		element.querySelectorAll('.invalid-feedback').forEach((error) => {
			error.remove();
		});
	} else {
		if (element.closest('[data-live-validation-group]')) {
			element = element.closest('[data-live-validation-group]');
		}

		element.classList.remove('is-invalid');

		const nextElement = element.nextElementSibling;
		if (nextElement?.classList.contains('invalid-feedback')) {
			nextElement.remove();
		}
	}
}

function processEventAfterChange(input) {
	removeErrors(input);

	Nette.formErrors = [];
	Nette.validateControl(input);
	showErrors(Nette.formErrors);
}

function initLiveValidation(element) {
	element.querySelectorAll('[data-live-form-validation]').forEach((form) => {
		form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
			input.addEventListener('change', (e) => {
				processEventAfterChange(input);
			});
		});

		form.querySelectorAll('input[type="radio"]').forEach((input) => {
			input.addEventListener('change', (e) => {
				processEventAfterChange(input);
			});
		});

		form.querySelectorAll('select').forEach((input) => {
			input.addEventListener('change', (e) => {
				processEventAfterChange(input);
			});
		});

		form.querySelectorAll('input').forEach((input) => {
			input.addEventListener('keydown', (e) => {
				removeErrors(input);
			});
		});


		form.querySelectorAll('input,textarea').forEach((input) => {
			input.addEventListener('blur', (e) => {
				Nette.formErrors = [];
				Nette.validateControl(input);
				showErrors(Nette.formErrors);
			});
			if (input.tagName.toLowerCase() === 'textarea') {
				input.addEventListener('keyup', (e) => {
					removeErrors(input);
					Nette.formErrors = [];
					Nette.validateControl(input);
					showErrors(Nette.formErrors);
				});
			}
		});
	});
}

export default function () {
	Nette.showFormErrorsOriginal = Nette.showFormErrors;

	Nette.showFormErrors = function (form, errors) {
		if (form.dataset.liveFormValidation) {
			removeErrors(form);
			showErrors(errors, true);
		} else {
			Nette.showFormErrorsOriginal(form, errors);
		}
	};

	$.nette.ext('live-form-validation', {
		init: function () {
			initLiveValidation(document);

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initLiveValidation($el.get(0));
				}
			});
		}
	});
}
